import { Logger } from 'utils/logger';

/**
 * Utility function to get the current auth token from Stytch client
 */
export const getAuthToken = (stytchClient: any): string | null => {
  try {
    if (stytchClient && typeof stytchClient.session.getTokens === 'function') {
      const tokens = stytchClient.session.getTokens();
      // Use only session_jwt for Bearer auth (no fallback to session_token)
      return tokens?.session_jwt || null;
    }
    return null;
  } catch (err) {
    Logger.error('Error getting auth token:', err);
    return null;
  }
};
